import(/* webpackMode: "eager" */ "/app/src/app/[festival-slug]/[locale]/(auth)/account/order-history/page.tsx");
